export const types = {
    // CALENDAR TYPES
    RECEIVED_CALENDAR: 'RECEIVED_CALENDAR',
    RECEIVED_NEXT_CALENDAR: 'RECEIVED_NEXT_CALENDAR',
    RECEIVED_LAST_CALENDAR: 'RECEIVED_LAST_CALENDAR',
    RECEIVED_CALENDAR_DAY: 'RECEIVED_CALENDAR_DAY',
    GET_ALL_SBM_PROVIDERS: 'GET_ALL_SBM_PROVIDERS',

    // VIDEO CONSULT TYPES
    VIDEO_CODE_VERIFIED: 'VIDEO_CODE_VERIFIED',
    RECEIVED_TOKEN_SUCCESS: 'RECEIVED_TOKEN_SUCCESS',
    RECEIVED_TOKEN_FAIL: 'RECEIVED_TOKEN_FAIL',
    SESSION_DATA: 'SESSION_DATA',
    CONFIRM_END_CALL_DIALOG_OPEN: 'CONFIRM_END_CALL_DIALOG_OPEN',
    CONFIRM_END_CALL_NAVIGATION_LOCATION: 'CONFIRM_END_CALL_NAVIGATION_LOCATION',
    GET_OTHER_VIDEO_USERS_DATA_BY_TYPE_SUCCESS: 'GET_OTHER_VIDEO_USERS_DATA_BY_TYPE_SUCCESS',
    GET_CONSULT_SERVICE_DATA_SUCCESS: 'GET_CONSULT_SERVICE_DATA_SUCCESS',

    // AUTHENTICATION TYPES
    LOG_IN_SUCCESS: 'LOG_IN_SUCCESS',
    LOG_OUT_SUCCESS: 'LOG_OUT_SUCCESS',
    LOG_IN_FAIL: 'LOG_IN_FAIL',
    SIGN_UP_FAIL: 'SIGN_UP_FAIL',
    FETCH_AUTH_DATA_SUCCESS: 'FETCH_AUTH_DATA_SUCCESS',
    REGISTER_COMPANY_DATA_SUCCESS: 'REGISTER_COMPANY_DATA_SUCCESS',
    PASSWORD_STRENGTH_SCORE: 'PASSWORD_STRENGTH_SCORE',
    LOG_OUT_FAIL: 'LOG_OUT_FAIL',
    RESET_CLIENT_DATA: 'RESET_CLIENT_DATA',
    CLEAR_USER_DATA: 'CLEAR_USER_DATA',
    PASSWORD_RESET_FAIL: 'PASSWORD_RESET_FAIL',
    PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
    EMAIL_VERIFIED: 'EMAIL_VERIFIED',
    AUTH_FLOW_IN_PROCESS: 'AUTH_FLOW_IN_PROCESS',
    SET_LOGIN_DIALOG_OPEN: 'SET_LOGIN_DIALOG_OPEN',
    SET_LOGIN_DIALOG_CLOSED: 'SET_LOGIN_DIALOG_CLOSED',
    CLEAR_SERVER_ERROR: 'CLEAR_SERVER_ERROR',
    TOKEN_SIGNIN: 'TOKEN_SIGNIN',
    ACCOUNT_ACTIVATION_SUCCESS: 'ACCOUNT_ACTIVATION_SUCCESS',
    VALID_ACTIVATION_CODE: 'VALID_ACTIVATION_CODE',
    ACTIVATION_FORM_SUCCESS: 'ACTIVATION_FORM_SUCCESS',

    // USER DATA TYPES
    GET_PROVIDER_CLIENTS: "GET_PROVIDER_CLIENTS",
    GET_CLIENT_DATA_FAIL: 'GET_CLIENT_DATA_FAIL',
    GET_CLIENT_DATA_SUCCESS: 'GET_CLIENT_DATA_SUCCESS',

    // PROVIDER TYPES
    GET_ALL_DB_PROVIDERS: 'GET_ALL_DB_PROVIDERS',
    GET_PROVIDER_DATA: 'GET_PROVIDER_DATA',

    // AVAILABILITY TYPES
    GET_PROVIDER_AVAILABILITY: 'GET_PROVIDER_AVAILABILITY',
    GET_PROVIDER_EXCEPTIONS: 'GET_PROVIDER_EXCEPTIONS',
    GET_PROVIDER_DAYSOFF: 'GET_PROVIDER_DAYSOFF',
    SET_AVAILABILITY_UPDATE_STATUS: 'SET_AVAILABILITY_UPDATE_STATUS',

    // DIALOG TYPES
    SET_CURRENT_DIALOG: 'SET_CURRENT_DIALOG',

    // PAYMENT TYPES
    GET_CREDITS_SUCCESS: 'GET_CREDITS_SUCCESS',
    GET_CREDITS_FAIL: 'GET_CREDITS_FAIL',
    CREDITS_PAYMENT_SUCCESS: 'CREDIT_PAYMENT_SUCCESS',
    CREDITS_PAYMENT_FAIL: 'CREDIT_PAYMENT_FAIL',

    // TIMEZONE TYPES
    GET_USER_TIMEZONE_FAIL: 'GET_USER_TIMEZONE_FAIL',
    GET_USER_TIMEZONE_SUCCESS: 'GET_USER_TIMEZONE_SUCCESS',

    // BOOKING TYPES
    CONFIRM_BOOKING_DATA_SUCCESS: 'CONFIRM_BOOKING_DATA_SUCCESS',
    CONFIRM_BOOKING_DATA_FAIL: 'CONFIRM_BOOKING_DATA_FAIL',
    RESET_BOOKING_DATA: 'RESET_BOOKING_DATA',
    GET_ALL_CLIENT_BOOKINGS: 'GET_ALL_CLIENT_BOOKINGS',
    GET_PAST_CLIENT_BOOKINGS: 'GET_PAST_CLIENT_BOOKINGS',
    GET_FUTURE_CLIENT_BOOKINGS: 'GET_FUTURE_CLIENT_BOOKINGS',
    BOOKING_CANCEL_SUCCESS: 'BOOKING_CANCEL_SUCCESS',
    SET_BOOKING_PROVIDER: 'SET_BOOKING_PROVIDER',
    SET_BOOKING_SERVICE: 'SET_BOOKING_SERVICE',
    SET_BOOKING_DETAILS: 'SET_BOOKING_DETAILS',
    GET_NEW_CLIENT_BOOKING: 'GET_NEW_CLIENT_BOOKING',
    CLEAR_ALL_BOOKINGS: 'CLEAR_ALL_BOOKINGS',
    CONFIRM_NEW_BOOKING: 'CONFIRM_NEW_BOOKING',
    AWAIT_NEW_BOOKING: 'AWAIT_NEW_BOOKING',
    SAVE_TEMP_BOOKING_DATA: 'SAVE_TEMP_BOOKING_DATA',
    SAVE_CURRENT_BOOKING_CLIENT: "SAVE_CURRENT_BOOKING_CLIENT",
    SAVE_CURRENT_SELECTED_SERVICE: "SAVE_CURRENT_SELECTED_SERVICE",

    GET_ALL_PROVIDER_COMPANIES: 'GET_ALL_PROVIDER_COMPANIES',

    // SERVICE TYPES
    GET_ALL_SERVICE_MODULES: 'GET_ALL_SERVICE_MODULES',
    GET_ALL_SERVICE_CATEGORIES: 'GET_ALL_SERVICE_CATEGORIES',
    GET_ALL_SERVICES: 'GET_ALL_SERVICES',
    SET_SELECTED_SERVICE_SUCCESS: 'SET_SELECTED_SERVICE_SUCCESS',
    SET_SELECTED_SERVICE_FAIL: 'SET_SELECTED_SERVICE_FAIL',
    CLEAR_SERVICE_STATUSES: 'CLEAR_SERVICE_STATUSES',
    GET_SERVICE_MODULE_SUCCESS: 'GET_SERVICE_MODULE_SUCCESS',
    SAVE_SERVICE_RATING_SUCCESS: 'SAVE_SERVICE_RATING_SUCCESS',
    SAVE_SERVICE_REVIEW_SUCCESS: 'SAVE_SERVICE_REVIEW_SUCCESS',
    GET_SERVICE_REVIEW_FOR_USER_SUCCESS: 'GET_SERVICE_REVIEW_FOR_USER_SUCCESS',
    GET_ALL_SERVICE_REVIEWS_SUCCESS: 'GET_ALL_SERVICE_REVIEWS_SUCCESS',
    GET_SERVICE_RATING_FOR_USER_SUCCESS: 'GET_SERVICE_RATING_FOR_USER_SUCCESS',
    GET_ALL_SERVICE_RATINGS_SUCCESS: 'GET_ALL_SERVICE_RATINGS_SUCCESS',


    // WINDOW DIMENSION TYPES
    UPDATE_WINDOW_DIMENSIONS: 'UPDATE_WINDOW_DIMENSIONS',

    // LOCATION TYPES
    UPDATE_LOCATION: 'UPDATE_LOCATION',


    SET_SELECTED_CLIENT_SUCCESS: 'SET_SELECTED_CLIENT_SUCCESS',
    SET_SELECTED_CLIENT_FAIL: 'SET_SELECTED_CLIENT_FAIL',

    // SERVICE ACTIVITY STATUS TYPES
    ADD_INACTIVE_SERVICE_SUCCESS: 'ADD_INACTIVE_SERVICE_SUCCESS',
    ADD_PENDING_SERVICE_SUCCESS: 'ADD_PENDING_SERVICE_SUCCESS',
    ADD_ACTIVE_SERVICE_SUCCESS: 'ADD_ACTIVE_SERVICE_SUCCESS',
    ADD_CANCELLED_SERVICE_SUCCESS: 'ADD_CANCELLED_SERVICE_SUCCESS',
    ADD_SERVICE_BY_STATUS_FAIL: 'ADD_SERVICE_BY_STATUS_FAIL',

    // CLIENT ACTIVITY STATUS TYPES
    ADD_INACTIVE_CLIENT_SUCCESS: 'ADD_INACTIVE_CLIENT_SUCCESS',
    ADD_ACTIVE_CLIENT_SUCCESS: 'ADD_ACTIVE_CLIENT_SUCCESS',
    ADD_PENDING_CLIENT_SUCCESS: 'ADD_PENDING_CLIENT_SUCCESS',
    ADD_CLIENT_BY_STATUS_FAIL: 'ADD_CLIENT_BY_STATUS_FAIL',

    // THREAD COMMUNICATION/MESSAGING TYPES
    GET_COMMENT_STATUS: 'GET_COMMENT_STATUS',

    SET_IMAGE_LIKED_STATUS: 'SET_IMAGE_LIKED_STATUS',
    GET_IMAGE_LIKED_STATUS: 'GET_IMAGE_LIKED_STATUS',

    COMMENT_CHANGED: 'COMMENT_CHANGED',

    GET_MESSAGE_THREADS: 'GET_MESSAGE_THREADS',
    GET_MESSAGE_THREAD: 'GET_MESSAGE_THREAD',

    GET_MESSAGES_SUCCESS: 'GET_MESSAGES_SUCCESS',
    GET_LOG_MESSAGES_SUCCESS: 'GET_LOG_MESSAGES_SUCCESS',
    GET_LINK_MESSAGES_SUCCESS: 'GET_LINK_MESSAGES_SUCCESS',

    GET_MESSAGES_FAIL: 'GET_MESSAGES_FAIL',
    GET_LINK_MESSAGES_FAIL: 'GET_LINK_MESSAGES_FAIL',
    GET_LOG_MESSAGES_FAIL: 'GET_LOG_MESSAGES_FAIL',

    GET_MORE_MESSAGES_SUCCESS: 'GET_MORE_MESSAGES_SUCCESS',
    GET_MORE_LOG_MESSAGES_SUCCESS: 'GET_MORE_LOG_MESSAGES_SUCCESS',
    GET_MORE_LINK_MESSAGES_SUCCESS: 'GET_MORE_LINK_MESSAGES_SUCCESS',

    GET_NUTRITION_LOG_THREADS: 'GET_NUTRITION_LOG_THREADS',

    // NOTIFICATION TYPES
    GET_NEW_CHAT_NOTIFICATION_SUCCESS: 'GET_NEW_CHAT_NOTIFICATION_SUCCESS',
    GET_NEW_NUTRITION_LOG_NOTIFICATION_SUCCESS: 'GET_NEW_NUTRITION_LOG_NOTIFICATION_SUCCESS',
    GET_NEW_NUTRITION_LOG_LIKES_NOTIFICATION_SUCCESS: 'GET_NEW_NUTRITION_LOG_LIKES_NOTIFICATION_SUCCESS',
    GET_NEW_NUTRITION_LOG_REVIEWS_NOTIFICATION_SUCCESS: 'GET_NEW_NUTRITION_LOG_REVIEWS_NOTIFICATION_SUCCESS',
    GET_NEW_NUTRITION_LOG_COMMENTS_NOTIFICATION_SUCCESS: 'GET_NEW_NUTRITION_LOG_COMMENTS_NOTIFICATION_SUCCESS',
    GET_NEW_BOOKINGS_NOTIFICATION_SUCCESS: 'GET_NEW_BOOKINGS_NOTIFICATION_SUCCESS',
    GET_NEW_EXPERT_CONTENT_NOTIFICATION_SUCCESS: 'GET_NEW_EXPERT_CONTENT_NOTIFICATION_SUCCESS',
    NOTIFICATION_SENT: 'NOTIFICATION_SENT',
    HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
    CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',

    GET_TOTAL_UNREAD_COUNT: 'GET_TOTAL_UNREAD_COUNT',
    RESET_TOTAL_UNREAD_COUNT: 'RESET_TOTAL_UNREAD_COUNT',
    GET_CHAT_COUNT: 'GET_CHAT_COUNT',
    GET_NL_COUNT: 'GET_NL_COUNT',
    GET_NL_LIKE_COUNT: 'GET_NL_LIKE_COUNT',
    GET_NL_REVIEW_COUNT: 'GET_NL_REVIEW_COUNT',
    GET_NL_COMMENT_COUNT: 'GET_NL_COMMENT_COUNT',
    GET_BOOKING_COUNT: 'GET_BOOKING_COUNT',
    GET_EXPERT_CONTENT_COUNT: 'GET_EXPERT_CONTENT_COUNT',

    SET_24_HOUR_TIME_SUCCESS: 'SET_24_HOUR_TIME_SUCCESS',
    SET_12_HOUR_TIME_SUCCESS: 'SET_12_HOUR_TIME_SUCCESS',

    UPLOADING_PHOTO_LOG_COMPLETED: 'UPLOADING_PHOTO_LOG_COMPLETED',
    UPLOADING_PHOTO_LOG_STARTED: 'UPLOADING_PHOTO_LOG_STARTED',
    UPLOADING_PHOTO_MESSAGE_STARTED: 'UPLOADING_PHOTO_MESSAGE_STARTED',
    UPLOADING_PHOTO_MESSAGE_COMPLETED: 'UPLOADING_PHOTO_MESSAGE_COMPLETED',
    SHOW_TOOLBAR: 'SHOW_TOOLBAR',
    HIDE_TOOLBAR: 'HIDE_TOOLBAR',


    // COMPANY TYPES
    GET_DB_PROVIDERS: 'GET_DB_PROVIDERS',
    GET_COMPANY_INFO: 'GET_COMPANY_INFO',
    GET_SERVICES: 'GET_SERVICES',
    SELECT_STAFF: 'SELECT_STAFF',
    SELECT_SERVICE: 'SELECT_SERVICE',
    RESET_SELECTIONS: 'RESET_SELECTIONS',
    CHANGE_WIZARD_STEP: 'CHANGE_WIZARD_STEP',
    FIND_CLIENT_BY_EMAIL: 'FIND_CLIENT_BY_EMAIL',
    SET_ACTIVATION_CODE: 'SET_ACTIVATION_CODE',
    CHANGE_DIALOG_STATUS: 'CHANGE_DIALOG_STATUS',
    SEND_COMPANY_NOTIFICATION: 'SEND_COMPANY_NOTIFICATION',
    HIDE_COMPANY_NOTIFICATION: 'HIDE_COMPANY_NOTIFICATION',
    FORM_SUBMISSION_SUCCESSFUL: 'FORM_SUBMISSION_SUCCESSFUL',
    SETUP_ADMIN_DATA: 'SETUP_ADMIN_DATA',
    COMPANY_CREATION_SUCCESS: 'COMPANY_CREATION_SUCCESS',

    // FORM TYPES
    SET_FORM_TYPE: 'SET_FORM_TYPE',

    // USER ACTIVTY/IDLE STATUS TYPES
    GET_USER_ACTIVITY_STATUS_FAIL: 'GET_USER_ACTIVITY_STATUS_FAIL',
    GET_USER_ACTIVITY_STATUS_SUCCESS: 'GET_USER_ACTIVITY_STATUS_SUCCESS',

    // BLUR PAGE TYPES
    BLUR_PAGE: 'BLUR_PAGE',

    // END VIDEO SESSION FORM TYPES
    GET_END_CONSULT_SESSION_REASON: 'GET_END_CONSULT_SESSION_REASON',
    MARK_CONSULT_AS_COMPLETE: 'MARK_CONSULT_AS_COMPLETE',

    // KPI TRACKER TYPES
    GET_KPI_DATA_SUCCESS: 'GET_KPI_DATA_SUCCESS',
}


// WEBPACK FOOTER //
// ./src/js/actions/types.js